import { render, staticRenderFns } from "./UploadNews.vue?vue&type=template&id=5c1f026b&scoped=true&"
import script from "./UploadNews.vue?vue&type=script&lang=js&"
export * from "./UploadNews.vue?vue&type=script&lang=js&"
import style0 from "./UploadNews.vue?vue&type=style&index=0&id=5c1f026b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1f026b",
  null
  
)

export default component.exports